const apis = [
  {
    // 团队分页列表
    fn: 'getPageList',
    method: 'POST',
    url: '/api/jsTeam/getPageList',
    hideLoading: true
  },
  {
    // 添加团队
    fn: 'add',
    method: 'POST',
    url: '/api/jsTeam/add',
    hideLoading: true
  },
  {
    // 修改团队
    fn: 'update',
    method: 'POST',
    url: '/api/jsTeam/update',
    hideLoading: true
  },
  {
    // 删除团队
    fn: 'delete',
    method: 'POST',
    url: '/api/jsTeam/delete',
    hideLoading: true
  },
  {
    // 团队详情
    fn: 'info',
    method: 'GET',
    url: '/api/jsTeam/info',
    hideLoading: true
  }
]

export default apis
